export { default } from './EmprestimoGarantiaCarroBlog';
